// extracted by mini-css-extract-plugin
export default {"profilePhoto":"KYcx6K","isCenterAlignment":"NTZPpf","isRightAlignment":"CWjEQd","noTitle":"KMywst"};